import { render } from "./TtVertical.vue?vue&type=template&id=6c52ceae"
import script from "./TtVertical.vue?vue&type=script&lang=js"
export * from "./TtVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__